import { render, staticRenderFns } from "./staff-profile-layout.vue?vue&type=template&id=8e45d646"
import script from "./staff-profile-layout.vue?vue&type=script&lang=js"
export * from "./staff-profile-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports